import { ApiProperty } from '../../codegen';
import {
  IsObject,
  IsNumber,
  IsOptional,
  Min,
  Max,
  IsUUID,
} from '../../validators';

import type { IGameAction } from './game-engine.types';

export class GameActionDto {
  @ApiProperty()
  @IsUUID()
  lobbyId: string;

  @ApiProperty()
  @IsNumber()
  @Min(0)
  @Max(1)
  playerSlot: number;

  @ApiProperty()
  @IsObject()
  action: IGameAction;
}

export class GameStateDto {
  @ApiProperty()
  @IsUUID()
  lobbyId: string;

  @ApiProperty()
  @IsObject()
  state: unknown;

  @ApiProperty()
  @IsNumber()
  @Min(0)
  @Max(1)
  playerSlotTurn: number;

  @ApiProperty()
  @IsOptional()
  isGameOver?: boolean;

  @ApiProperty()
  @IsOptional()
  winner?: number;
}
